import { mapValues } from 'utils/object'

// encodeQuery :: ({str: any}) -> str
export const encodeQuery = (
  data: Record<string, string | number | boolean>,
) => {
  const query = Object.entries(data)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&')
  return query && '?' + query
}

// parseQuery :: (str) -> {str: str}
export const parseQuery = (search: string) => {
  const pairs = search
    .replace(/^\?/, '')
    .split('&')
    .filter(pair => pair.length)
    .map(pair => pair.split('='))
  // Values are decoded after duplicate keys are dropped, so a malformed value
  // that a later duplicate replaces does not throw
  return mapValues(Object.fromEntries(pairs), value =>
    decodeURIComponent(String(value)),
  )
}
